import { createTestIds } from '@pega/cosmos-react-core';

export const elements = [
  'toolbar',
  'text-styles',
  'bold',
  'italic',
  'strike-through',
  'underline',
  'subscript',
  'superscript',
  'font-family',
  'font-size',
  'text-color',
  'background-color',
  'alignment',
  'align-left',
  'align-center',
  'align-right',
  'bulleted-list',
  'numbered-list',
  'indent',
  'unindent',
  'table',
  'link',
  'image',
  'source-code',
  'ai-rewrite',
  'overflow',
  'word-count'
] as const;

export const getToolbarTestIds = createTestIds('toolbar', elements);
